// extracted by mini-css-extract-plugin
module.exports = {"customButton":"RedButton_customButton__WzZmh"};